import * as React from 'react';

export interface StartProps {
  children?: React.ReactNode;
}

export default class Start extends React.PureComponent<StartProps> {}
